/**
 * @typedef {import('../../../interfaces/AUI/IDropdownButton.interface').IDropdownButtonItem} IDropdownButtonItem
 */

import React from 'react';
import { AUIButtonCell, AUIDropdownButtonCell } from '@ancert/aui-table-cell';

/**
 * @typedef {object} events
 * @property {Function} onRowEditar
 * @property {Function} onRowEliminar
 * @property {Function} onRowVer
 */

/**
 * @param {events} events
 * @param {object} row
 * @returns {Array<IDropdownButtonItem>}
 */
const getItems = ({ onRowEditar, onRowEliminar }, row) => [ 
    { label: 'Editar', command: () => onRowEditar(row) },
    { label: 'Eliminar', command: () => onRowEliminar(row) },
]

/**
 * @param {events} events
 * @param {boolean} onVer
 * @returns
 */
const getColumns = (events, onVer) => [
  {
    id: 'nombre',
    accessor: (row) => row.nombre,
    columnWidth: 112,
    header: 'Nombre',
    cell: ({ value }) => <>{value}</>,
  },
  {
    id: 'apellidos',
    accessor: (row) => row,
    columnWidth: 170,
    header: 'Apellidos',
    cell: ({ value }) => {
      const { apellido1, apellido2 } = value;
      return <>{`${apellido1} ${apellido2 || ''}`}</>;
    },
  },
  {
    id: 'cargo',
    accessor: (row) => row.cargo,
    columnWidth: 240,
    header: 'Cargo',
    cell: ({ value }) => <>{value}</>,
  },
  {
    id: 'hechos',
    accessor: (row) => row.hechos,
    header: 'Hechos acontecidos',
    cell: ({ value }) => <>{value}</>,
  },
  {
    id: 'action',
    columnWidth: 40,
    accessor: (row) => row,
    header: '',
    cell: ({ value }) => {
      if (onVer) {
        return <AUIButtonCell buttonList={[{ mode: 'ghost', label: 'Ver', onClick: () => events.onRowVer(value) }]} />;;
      }
      return <AUIDropdownButtonCell items={getItems(events, value)} />;
    },
  },
];

export default getColumns;
